module.exports = __webpack_public_path__ + "static/media/register-property-sofo-soho.872d0faf.png";